import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {catchError, Observable, of, switchMap, take} from 'rxjs';
import {ManagerAuthDialogComponent} from '../@components/manager-auth-dialog/manager-auth-dialog.component';
import {StaffAttendanceService} from './staff-attendance.service';
import {LocalstorageService} from './localstorage.service';

export interface ManagerAuthResult {
  success: boolean;
  username?: string;
  role?: string;
  remark?: string;
}

export interface ManagerAuthOptions {
  requireRemark?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ManagerAuthService {

  constructor(
    private dialog: MatDialog,
    private staffAttendanceService: StaffAttendanceService,
    private ls: LocalstorageService
  ) {}

  requireManagerAuth(options?: ManagerAuthOptions): Observable<ManagerAuthResult> {
    const merchant = this.ls.getMerchant();
    return this.staffAttendanceService.getSettings(merchant.id).pipe(
      catchError(() => of(null)),
      switchMap((settings) => {
        const methods: string[] = settings?.enabledMethods ? JSON.parse(settings.enabledMethods) : ['LIST'];
        const nfcEnabled = methods.includes('NFC');
        return this.openDialog(nfcEnabled, options);
      })
    );
  }

  private openDialog(nfcEnabled: boolean, options?: ManagerAuthOptions): Observable<ManagerAuthResult> {
    const isMobile = window.innerWidth < 768;
    const dialogRef = this.dialog.open(ManagerAuthDialogComponent, {
      width: isMobile ? '90vw' : '400px',
      disableClose: true,
      data: {
        requireRemark: options?.requireRemark ?? false,
        nfcEnabled
      }
    });

    return dialogRef.afterClosed().pipe(take(1));
  }
}
